<template>
	<popup v-model="innerVisible" position="bottom">
		<div class="m-footer-popup-header thinner-border-bottom">
			<span class="m-footer-title">{{ $t('enterprise.appointment-survey') }}</span>
			<SvgIcons name="icon_close" class="m-footer-close" @click="closePopup" />
		</div>
		<div class="m-footer-popup-main">
			<img v-if="posterQrCodeUrl" :src="posterQrCodeUrl" alt="" />
		</div>
		<div class="qrcode-canvas" ref="shadowCanvas"></div>
	</popup>
</template>

<script setup>
import { Popup } from 'vant';
import { ref, computed, nextTick } from 'vue';
import * as QRCode from 'easyqrcodejs';
import { useCommonData } from '@/hooks';

const props = defineProps({
	visible: {
		type: Boolean,
		default: false
	}
});
const emits = defineEmits(['update:visible']);
const innerVisible = computed({
	get() {
		if (props.visible) qrcodeDataURL();
		return props.visible;
	},
	set(val) {
		emits('update:visible', val);
	}
});
// TODO 老铺黄金定制化逻辑
const { getColumnData, isLAOPU, COLOR_LAOPU, generateMobileModuleUrl } = useCommonData();

const closePopup = () => {
	innerVisible.value = false;
};

const shadowCanvas = ref();
const posterQrCodeUrl = ref('');
const qrcodeDataURL = () => {
	const { logo } = getColumnData.value;

	const qrcodeURL = generateMobileModuleUrl('appointment');
	const width = 256;
	const height = 256;
	const config = {
		colorDark: isLAOPU.value ? COLOR_LAOPU : '#333', //二维码颜色
		colorLight: '#fff', //二维码背景色
		correctLevel: QRCode.CorrectLevel.M, //容错率，L/M/H
		logo: logo,
		crossOrigin: 'anonymous',
		quietZone: 0,
		width,
		height,
		logoWidth: width / 5,
		logoHeight: height / 5
	};

	nextTick(() => {
		new QRCode(shadowCanvas.value, {
			...config,
			text: qrcodeURL,
			onRenderingEnd: (options, dataURL) => {
				posterQrCodeUrl.value = dataURL;
			}
		});
	});
};
</script>

<style>
.van-popup {
	border-radius: 8px 8px 0 0;
}
</style>
<style lang="less" scoped>
.m-footer-popup-header {
	height: 50px;
	display: flex;
	justify-content: center;
	align-items: center;
	position: relative;

	/deep/ &.thinner-border-bottom::before {
		border-bottom-color: #f0f0f0;
	}
	.m-footer-title {
		color: #12121a;
		text-align: center;
		 
		font-size: 16px;
		font-weight: 500;
	}
	.m-footer-close {
		position: absolute;
		top: 0;
		right: 16px;
		bottom: 0;
		margin: auto;
		font-size: 16px;
	}
}
.m-footer-popup-main {
	padding: 12px 14px 58px;
	display: flex;
	flex-direction: column;
	align-items: center;
	img {
		width: 170px;
		height: 170px;
	}
}
.qrcode-canvas {
	width: 0;
	height: 0;
	display: none;
}
</style>
